// extracted by mini-css-extract-plugin
export default {"main_page":"NissanMicra_main_page__w7sP-","car_image":"NissanMicra_car_image__c41-Y"};